export class MotivosUacModel {
    public motivoConsulta: string;
    public id: string;
    public estado: string;
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public usuarioModificacion: string;
    public descripcion: string;

}